<template>
  <div class="box p-4" data-test="filter">
    <div class="flex justify-between items-baseline mb-3">
      <h2 class="text-lg text-theme-2 font-semibold">
        เงื่อนไขการค้นหา
      </h2>
      <div class="form-check" v-if="advanceOption">
        <label
          class="form-check-label mr-2 text-xs text-gray-600"
          for="checkbox-switch"
        >
          ขั้นสูง
        </label>
        <input
          id="checkbox-switch"
          class="form-check-switch"
          type="checkbox"
          v-model="modelValueComputed"
        />
      </div>
    </div>
    <slot />
  </div>
</template>

<script setup>
import { computed } from "vue";
const props = defineProps({
  modelValue: { type: Boolean, default: false },
  advanceOption: { type: Boolean, default: true },
});

const emits = defineEmits(["update:modelValue"]);

const modelValueComputed = computed({
  get() {
    return props.modelValue;
  },
  set(val) {
    emits("update:modelValue", val);
  },
});
</script>
